'use es6';

import keyMirror from 'react-utils/keyMirror';
const RecordType = keyMirror({
  REPORT: null,
  DASHBOARD: null
});
export default RecordType;